import { render, staticRenderFns } from "./EditIframeCreator.vue?vue&type=template&id=68064244&"
import script from "./EditIframeCreator.vue?vue&type=script&lang=js&"
export * from "./EditIframeCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports